import axios from 'axios';

import * as Sentry from '@sentry/react';
import {jwtDecode} from 'jwt-decode';

const excludedURLs = [
    '/login',
]

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

/*
apiClient.interceptors.response.use(
    response => {
        if (response.config.url.includes('refreshtoken')) {
            if (response.status > 200) {
                const requestData
                    = response.config
                        ? safeStringify(response.config.data) 
                        : null
                ;
                const responseData = response
                    ? safeStringify(response.data) 
                    : null
                ;

                const sentryError = new Error(
                    `HTTP Non-200 Success for refreshtoken: ${response.status} ${response.statusText} ${response.config.url}`
                );

                // Record the response in Sentry
                Sentry.captureException(sentryError, {
                    extra: {
                        request: {
                            url: response.config.url,
                            method: response.config.method,
                            headers: response.config.headers,
                            body: requestData,
                        },
                        response: {
                            status: response.status,
                            headers: response.headers,
                            body: responseData,
                        },
                    },
                });
            }
        }        

        return response;
    },
    error => {
        if (
            error.response &&
                error.response.status >= 400
                && error.response.status < 600
                && error.response.status !== 409
        ) {
            // Capture request and response details
            const requestData = error.config ? safeStringify(error.config.data) : null;
            const responseData = error.response ? safeStringify(error.response.data) : null;

            // Create an error object with additional context
            const sentryError = new Error(
                `HTTP Error: ${error.response.status} ${error.response.statusText} ${error.config.url}`
            );
            Sentry.captureException(sentryError, {
                extra: {
                    request: {
                        url: error.config.url,
                        method: error.config.method,
                        headers: error.config.headers,
                        body: requestData,
                    },
                    response: {
                        status: error.response.status,
                        headers: error.response.headers,
                        body: responseData,
                    },
                },
            });
        }

        return Promise.reject(error);
    }
);

apiClient.interceptors.request.use(
    config => {
        if (isExcludedURL(config.url)) {
            console.log('################### No check run')
            return config;
        }

        const token = localStorage.getItem('token'); 

        const currentTime = Math.floor(Date.now() / 1000);
        if (token) {
            const decodedToken = jwtDecode(token);

            if (decodedToken) {
                // Current time in seconds (epoch)

                // Token expiry check
                if (decodedToken.exp && decodedToken.exp <= currentTime) {
                    Sentry.captureException(new Error('Expired JWT used in API call'), {
                        extra: {
                            token: decodedToken,
                            currentTime,
                            url: config.url,
                            method: config.method,
                            requestPayload: safeStringify(config.data)
                        },
                    });
                }
            }
        } else {
            Sentry.captureException(new Error('API call without JWT'), {
                extra: {
                    currentTime,
                    url: config.url,
                    method: config.method,
                    requestPayload: safeStringify(config.data)
                },
            });
        }

        return config;
    },
    error => {
        Sentry.captureException(new Error(`Request Error (from interceptor): ${error.message}`), {
            extra: {
                request: {
                    url: error.config?.url,
                    method: error.config?.method,
                    headers: error.config?.headers,
                    body: safeStringify(error.config?.data),
                },
            },
        });

        return Promise.reject(error);
    }
);
*/

function safeStringify(body) {
    try {
        return JSON.stringify(body);
    } catch (error) {
        return String(body);
    }
}

function isExcludedURL(url) {
    return excludedURLs.some(excludedURL => url.includes(excludedURL));
}

export default apiClient;

